import { useState } from 'react'
import Logo from '../assets/logotransparent.png'

const NavigationBar=() => {

  const [state, setState] = useState(false)

  const navigation = [
      { title: "About me", path: "#aboutme" },
      { title: "Skills", path: "#skills" },
      { title: "Projects", path: "#projects" },
      { title: "Experience", path: "#experience" },
      { title: "My blogs", path: "#blogs" },
      { title: "Contact Me", path: "#contact" },
  ]

  return (
      <nav className="pt-5 w-full z-40">
          <div className="items-center px-1 max-w-screen-xl mx-auto lg:flex lg:px-2">
              <div className="flex items-center justify-center py-3 md:py-5 lg:block">
                    <a href="/">
                        <img
                            src={Logo} 
                            width={200} 
                            height={100}
                            alt="Mukka Deepak"
                        />
                    </a>
                  <div className="lg:hidden">
                      <button className="text-white outline-none p-2 rounded-md"
                          onClick={() => setState(!state)}
                      >
                          {
                              state ? (
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                  </svg>
                              ) : (
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
                                  </svg>
                              )
                          }
                      </button>
                  </div>
              </div>
              <div className={`flex-1 justify-center text-center pb-3 mt-8 lg:block lg:pb-0 lg:mt-0 ${ state ? 'block' : 'hidden'}`}>
                  <ul className="justify-center lg:justify-end items-center space-y-4 lg:flex lg:space-x-6 lg:space-y-0">
                      {
                          navigation.map((item, idx) => {
                              return (
                                <li key={idx} className="text-white font-medium pr-4 hover:text-gray-300 md:text-xl text-base transition ease-out delay-50  hover:-translate-y-1 hover:scale-102">
                                    <a href={item.path}>
                                        { item.title }
                                    </a>
                                </li>
                              )
                          })
                      }
                  </ul>
              </div>
              {/* <div className="hidden lg:inline-block">
                <a href={Resume}className="py-3 px-4 text-white bg-[#4A6CF7] hover:bg-[#3468d0cc] rounded-md shadow" download="Mukka's Resume">
                   Download resume
                </a>
              </div> */}
          </div>
      </nav>
  )
}

export default NavigationBar;